<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Edit Product">
        <button @click="$router.go(-1)">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            color="white"
            absolute
            top
            right
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </button>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"
                  >Product ID <span class="error--text">*</span></label
                >
                <v-text-field
                  class="my-1 py-0"
                  v-model="productObj.productId"
                  required
                  disabled
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"
                  >Discount to Parents <span class="error--text">*</span></label
                >
                <v-text-field
                  class="my-1 py-0"
                  placeholder="Discount to Parents"
                  required
                  v-model="productObj.discountToParent"
                  :rules="[numberValidation]"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"
                  >Retailer Margin <span class="error--text">*</span></label
                >
                <v-text-field
                  class="my-1 py-0"
                  placeholder="Retailer Margin"
                  v-model="productObj.retailerMargin"
                  required
                  :rules="[numberValidation]"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'

export default {
  name: 'updateProduct',
  components: { MaterialCard },
  props: ['productID'],
  data: function () {
    return {
      productObj: {
        productId: '',
        discountToParent: '',
        retailerMargin: ''
      },
      loadingComponent: null,
      minValue: 1,
      maxValue: 100
    }
  },
  async created () {
    this.isLoading = true
    await this.getProductById(this.productID)
  },
  methods: {
    getProductById: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${CONSTANTS.API_URL}/api/product/getProductInfo/${this.productID}`
        )
        const productDetails = response.data
        this.productObj = {
          productId: productDetails.productID,
          discountToParent: productDetails.discountToParent,
          retailerMargin: productDetails.retailerMargin
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    save: async function () {
      try {
        this.isLoading = true
        if (
          this.productObj.retailerMargin > 99 ||
          this.productObj.discountToParent > 99
        ) {
          this.errMsg('Maximum value should be 99 only')
        } else if (
          this.productObj.retailerMargin < 0 ||
          this.productObj.discountToParent < 0
        ) {
          this.errMsg('Minimum value should be 1 only')
        } else {
          const data = {
            discountToParent: this.productObj.discountToParent,
            retailerMargin: this.productObj.retailerMargin
          }

          await http.put(
            `${CONSTANTS.API_URL}/api/product/retail-margin/${this.productID}`,
            data
          )
          this.okMsg('Product updated successfully!')
          this.$router.push({
            name: 'ProductsRetailerMargin',
            params: { current: 1 }
          })
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    numberValidation (value) {
      if (!value) {
        return 'Value is required'
      }
      if (isNaN(value)) {
        return 'Value must be a number'
      }
      if (!/^[-+]?[0-9]+\.[0-9]+$/.test(value)) {
        return 'Value must be a decimal number'
      }
      return true
    },

    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
